import { NegativeFeedbackReasonEnum } from "../../../enums/negative-feedback-reason.enum";

export const negativeFeedbackReasons = Object.values(NegativeFeedbackReasonEnum);

export const NEGATIVE_FEEDBACK_REASON_MAPPING: Record<NegativeFeedbackReasonEnum, string> = {
  [NegativeFeedbackReasonEnum.WRONG]: "Sbagliata",
  [NegativeFeedbackReasonEnum.PARTIALLY_CORRECT_OR_INCOMPLETE]: "In parte corretta/sbagliata",
  [NegativeFeedbackReasonEnum.OFF_TOPIC]: "Fuori tema/non mi ha aiutato",
  [NegativeFeedbackReasonEnum.OTHER]: "Altro",
};

export const POSITIVE_FEEDBACK_TITLE = "Grazie per il feedback!";
export const NEGATIVE_FEEDBACK_REQUEST_REASON_TITLE = "Cosa non ha funzionato nella risposta?";
export const NEGATIVE_FEEDBACK_THANK_YOU_TITLE = "Grazie per il feedback. Ci aiuterà a migliorare!";
